import baustein from "baustein";
import template from "templates/modules/search_results";

var DISABLED_MODIFIER = "search-results--disabled";

baustein.register("search-results", {
    template: template,

    defaultOptions: {
        disabled: false,
    },

    init: function() {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },

    onOptionsChange: function() {
        this.el.classList.toggle(DISABLED_MODIFIER, this.options.disabled);
    },

    show: function() {
        this.el.classList.remove("hidden");
    },

    hide: function() {
        this.el.classList.add("hidden");
    },
});
